import IndustryPageTemplate from "./IndustryPageTemplate";
import { coachesData } from "@/data/coaches";

export default function CoachesPage() {
  return <IndustryPageTemplate data={coachesData} />;
}
